import createIcon from '../../createIcon';

/**
 * @component @name ImportExport
 * @description Google Material SVG icon component, renders SVG Element with children.
 *
 * @preview ![img](data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjQiIGhlaWdodD0iMjQiIHZpZXdCb3g9IjAgMCAyNCAyNCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj48cGF0aCBkPSJNOSAzTDUgNi45OUg4VjE0SDEwVjYuOTlIMTNMOSAzWk0xNiAxNy4wMVYxMEgxNFYxNy4wMUgxMUwxNSAyMUwxOSAxNy4wMUgxNloiIGZpbGw9ImJsYWNrIi8+Cjwvc3ZnPgo=)
 *
 * @param {Object} props - Google Material icons props and any valid SVG attribute
 * @returns {JSX.Element} JSX Element
 *
 */
const ImportExport = createIcon('ImportExport', [
  [
    'path',
    {
      d: 'M9 3L5 6.99H8V14H10V6.99H13L9 3ZM16 17.01V10H14V17.01H11L15 21L19 17.01H16Z',
      key: 'ikpu25',
    },
  ],
]);

export default ImportExport;
